import { getLoginToken, getFileServerInfo } from '../../../../index'
import { uploadToServer, downloadFromServer } from './fileRealServe'
// import  FILESERVE_STATUS  from './fileServeStatus'
// import { getMockDownloadUrl } from './mockFileServe'

// export funcs
export const doUpload = (...args) => {
	if (!args[0].blob) {
		args[0].onError && args[0].onError('未选择上传文件')
		return null
	}

	return getFileServerInfo().upload ? getFileServerInfo().upload(...args) : uploadToServer(...args)
	// return uploadToServer(...args)
}

export const doDownload = (...args) => {
	if (!args[0].value.FID) {
		args[0].onError && args[0].onError('无文件编号用于下载')
		return null
	}

	return getFileServerInfo().download ? getFileServerInfo().download(...args) : downloadFromServer(...args)
}

export { getDownloadUrl, getRtaUrl } from './fileRealServe'
